import colorModeReducer from '@lib/store/colorModeSlice';
import { configureStore } from '@reduxjs/toolkit';

/** UI-only Redux store (theme). Server state belongs in TanStack Query / `@lib/api`. */
export const store = configureStore({
  reducer: {
    colorMode: colorModeReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
